import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Phone } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { fetchInterested, resolveOffer } from "@/lib/api";
import { waLink } from "@/lib/wa";

const when = (iso) => {
  const h = Math.floor((Date.now() - new Date(iso).getTime()) / 3600000);
  return h < 1 ? "acum" : h < 24 ? `acum ${h} h` : `acum ${Math.floor(h / 24)} zile`;
};

export default function InterestedList({ showAgent }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    fetchInterested().then(setRows).catch(() => setRows([]));
  }, []);
  const done = (id) => resolveOffer(id).then(() => setRows((r) => r.filter((x) => x.id !== id))).catch(() => toast.error("Nu am putut marca"));
  if (!rows) return null;
  return (
    <section className="interested" data-testid="interested-list">
      <div className="st-section-title"><Phone size={12} /> Clienți interesați · au deschis oferta, n-au comandat ({rows.length})</div>
      {!rows.length && <p className="st-hint">Niciun client în așteptare.</p>}
      <ul>
        {rows.map((o) => {
          const wa = waLink(o.phone, `Bună ziua! Am văzut că v-ați uitat la oferta ${o.pack_name}. Vă pot ajuta cu comanda?`);
          return (
            <li key={o.id} data-testid={`interested-row-${o.id}`}>
              <div>
                <b>{o.salon}</b>
                <span>{o.pack_name} · deschisă de {o.opens}× · ultima dată {when(o.last_open)}{showAgent && o.agent ? ` · agent ${o.agent}` : ""}</span>
                {o.phone && <span>{o.phone}</span>}
              </div>
              <div className="interested-actions">
                {o.phone && <a className="st-btn st-btn--ghost" href={`tel:${o.phone.replace(/\s/g, "")}`} data-testid={`interested-call-${o.id}`}><Phone size={13} /> Sună</a>}
                {wa && <a className="st-btn st-btn--ghost" href={wa} target="_blank" rel="noopener noreferrer" data-testid={`interested-wa-${o.id}`}><WhatsAppGlyph /> WhatsApp</a>}
                <button type="button" className="st-btn st-btn--light" onClick={() => done(o.id)} data-testid={`interested-resolve-${o.id}`}><Check size={13} /> Rezolvat</button>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
